<script setup>
import { ref, onMounted } from 'vue'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'

const { menuVisible } = useMenu();
const { submenuVisible } = useSubmenu();
const { topbarVisible } = useTopBar();
</script>

<template>
  <div id="mount-toast" class="mount-toast" :class="{ 'toast-menu-offset': menuVisible, 'toast-topbar-offset': topbarVisible }"></div>
</template>

<style scoped>
.mount-toast {
  @apply fixed z-10 top-10 left-0 w-full place-items-center gap-0;
  z-index: 900;
}

.mount-toast.toast-menu-offset {
  @apply pl-16;
}

.mount-toast.toast-topbar-offset {
  @apply top-20;
}
</style>
